import React from 'react';

const Broadcasting = () => {
    return (
        <div>Broadcasting</div>
    )
}

export default Broadcasting;